var map = {
	"./favicon.png": "iSXs",
	"./karaoke.jpg": "1yc3",
	"./noordkaap.jpg": "0r1Q",
	"./og-image.jpg": "T29S",
	"./tips/tip_1.jpg": "bL5f",
	"./tips/tip_2.jpg": "fmAY",
	"./tips/tip_3.jpg": "WDzR",
	"./tips/tip_4.jpg": "wiuH",
	"./tips/tip_5.jpg": "k1cU",
	"./tips/tip_6.jpg": "KoCw",
	"./tutorial.jpg": "2mLz"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dYTa";